import { useState, useEffect } from "react";
import api from "../constant/api";

export function useMenuPermission(menuId) {
  const [permissions, setPermissions] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
    canPdf: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const userEmail = localStorage.getItem("userEmail");

        if (!userEmail) {
          setLoading(false);
          return;
        }

        const allowedRes = await api.get(`/api/admin/get-allowed-menus?email=${userEmail}`);
        

        if (allowedRes.data && allowedRes.data.success) {
          const userPermissions = allowedRes.data.data; // e.g., ["4_view", "4_create", "4_edit", "4_delete"]
          
          const mappedPermissions = {
            canView: userPermissions.includes(`${menuId}_view`) || userPermissions.includes(`${menuId}_can_view`),
            
            canAdd: userPermissions.includes(`${menuId}_new`) || 
                    userPermissions.includes(`${menuId}_create`) || 
                    userPermissions.includes(`${menuId}_can_create`),
            
            canEdit: userPermissions.includes(`${menuId}_edit`) || userPermissions.includes(`${menuId}_can_edit`),
            
            canDelete: userPermissions.includes(`${menuId}_del`) || 
                       userPermissions.includes(`${menuId}_delete`) || 
                       userPermissions.includes(`${menuId}_can_delete`),

           canPdf: userPermissions.includes(`${menuId}_pdf`) || userPermissions.includes(`${menuId}_can_pdf`),
          };

          setPermissions(mappedPermissions);
        } else {
          console.error("❌ API not call NO Data:", allowedRes.data);
        }
      } catch (err) {
        console.error(`❌ Error checking permissions for Menu ID ${menuId}:`, err);
      } finally {
        setLoading(false);
      }
    };

    if (menuId) {
      checkPermissions();
    }
  }, [menuId]);

  return { permissions, loading };
}